import mongoose from 'mongoose';

export enum EContentPosition {
  left = 'left',
  right = 'right'
}

export enum EBillboardBannerStatus {
  inactive,
  active
}

export interface IBillboardBanner {
  subTitleVi: string;
  titleVi: string;
  contentPosition: EContentPosition;
  bannerImage: mongoose.Types.ObjectId;
  buttonLabelVi: string;
  buttonLink: string;
  status: EBillboardBannerStatus;
}
